import { useState, useEffect } from 'react';

export function useWeekendCampaignModal() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hasScrolledEnough, setHasScrolledEnough] = useState(false);

  useEffect(() => {
    // Check if user has dismissed the modal before
    const isDismissed = localStorage.getItem('weekend-campaign-dismissed') === 'true';
    
    if (isDismissed) {
      return; // Don't show modal if previously dismissed
    }

    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const documentHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;
      const scrollPercentage = scrollTop / (documentHeight - windowHeight);

      // Show modal when user has scrolled 35%
      if (scrollPercentage >= 0.15 && !hasScrolledEnough) {
        setHasScrolledEnough(true);
        // Small delay to make it feel more natural
        setTimeout(() => {
          setIsModalOpen(true);
        }, 500);
      }
    };

    // Throttle scroll events for better performance
    let ticking = false;
    const throttledHandleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', throttledHandleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', throttledHandleScroll);
    };
  }, [hasScrolledEnough]);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const resetDismissedState = () => {
    localStorage.removeItem('weekend-campaign-dismissed');
    setHasScrolledEnough(false);
    setIsModalOpen(false);
  };

  return {
    isModalOpen,
    closeModal,
    resetDismissedState
  };
}